// extracted by css-extract-rspack-plugin
export default {"sidebarLink":"sidebarLink-ctIQtY","collapsed":"collapsed-KgjuOe","active":"active-YL0bl2","sidebarIcon":"sidebarIcon-GpdMuh","sidebarTitle":"sidebarTitle-tXlrLJ"};